module.exports = __webpack_public_path__ + "static/media/fabio-mangioneOld.f26c34bb.jpg";